/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remind_Me_LaterInputs */

const en_remind_me_later = /** @type {(inputs: Remind_Me_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remind Me Later`)
};

const fr_remind_me_later = /** @type {(inputs: Remind_Me_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me le rappeler plus tard`)
};

const de_remind_me_later = /** @type {(inputs: Remind_Me_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erinnere mich später`)
};

const it_remind_me_later = /** @type {(inputs: Remind_Me_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricordamelo più tardi`)
};

const ru_remind_me_later = /** @type {(inputs: Remind_Me_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Напомни мне позже`)
};

const es_remind_me_later = /** @type {(inputs: Remind_Me_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuérdamelo más tarde`)
};

const zh_cn2_remind_me_later = /** @type {(inputs: Remind_Me_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稍后提醒我`)
};

const ja_remind_me_later = /** @type {(inputs: Remind_Me_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`後で通知する`)
};

const hi_remind_me_later = /** @type {(inputs: Remind_Me_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुझे बाद में याद दिलाएं`)
};

const pt_pt2_remind_me_later = /** @type {(inputs: Remind_Me_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembre-me mais tarde`)
};

/**
* | output |
* | --- |
* | "Remind Me Later" |
*
* @param {Remind_Me_LaterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remind_me_later = /** @type {((inputs?: Remind_Me_LaterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remind_Me_LaterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remind_me_later(inputs)
	if (locale === "de") return de_remind_me_later(inputs)
	if (locale === "it") return it_remind_me_later(inputs)
	if (locale === "ru") return ru_remind_me_later(inputs)
	if (locale === "es") return es_remind_me_later(inputs)
	if (locale === "zh-CN") return zh_cn2_remind_me_later(inputs)
	if (locale === "ja") return ja_remind_me_later(inputs)
	if (locale === "hi") return hi_remind_me_later(inputs)
	if (locale === "pt-PT") return pt_pt2_remind_me_later(inputs)
	return en_remind_me_later(inputs)
});